import React from 'react';

import './card.css';

const Card = ({children, className})=>{
  let finalClasses='card';
  if(className) finalClasses+=' '+className;
  return <div className={finalClasses}>{children}</div>
}

export default Card;